module.exports = __webpack_public_path__ + "static/img/boy.16f91129.png";